import { useParams, Link } from 'react-router-dom';
import { useState } from 'react';
import instance from '../config/axios';
import PasswordChecklist from 'react-password-checklist';
import passwordValidator from 'password-validator';
import showToast from '../components/ToastComponent';
import { useAuth } from 'react-oidc-context';

const ResetPassword = () => {
  const { id } = useParams();
  const [show, setShow] = useState(false);
  const [password, setPassword] = useState('');
  const [submit, setSubmit] = useState(false);
  const validPassword = new passwordValidator();
  const auth = useAuth();

  const resetPassword = async () => {
    try {
      const res = await instance.put('/api/v1/reset-password', {
        password,
        id,
      });

      if (res.status === 200) {
        showToast({
          message: res.data.message,
          type: 'success',
        });
        setSubmit(true);
        if (auth.isAuthenticated) {
          auth.signoutRedirect();
        }
      } else {
        showToast({
          message: res.data.message,
          type: 'warning',
        });
      }
    } catch (err) {
      console.log(err);
      showToast({
        message: 'Error reseting the password',
        type: 'error',
      });
    }
  };

  const validatedPassword = () => {
    validPassword
      .is()
      .min(8)
      .has()
      .uppercase()
      .has()
      .not()
      .spaces()
      .has()
      .symbols()
      .has()
      .digits(1);

    if (validPassword.validate(password)) return true;

    return false;
  };

  return (
    <>
      {submit ? (
        <div className=" px-6 py-8 sm:py-16 lg:px-8 text-center">
          <div className="mx-auto max-w-2xl">
            <p className="text-center text-xl lg:text-2xl text-primary-blue-500 font-regular mt-2 lg:mt-0">
              Password successfully created. Click Sign in to continue.
            </p>
            <p className="mt-10">
              <Link to={'/home'} reloadDocument={true}>
                <button
                  type="button"
                  className="rounded-md bg-secondary-cornflowerblue-600 px-10 py-2 text-center text-sm font-semibold text-white"
                >
                  Sign in
                </button>
              </Link>
            </p>
          </div>
        </div>
      ) : (
        <div className=" px-6 py-8 sm:py-16 lg:px-8">
          <div className="mx-auto max-w-2xl">
            <p className="text-center text-xl lg:text-2xl text-primary-blue-500 font-regular mt-2 lg:mt-0">
              Set Password
            </p>
            <div className="mt-7 text-lg leading-8 text-gray-600 ">
              <div className="relative mt-2 rounded-md shadow-sm w-3/4 mx-auto">
                <input
                  type={show ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  name="account-number"
                  id="account-number"
                  className="text-sm font-regular border  
                    rounded-md p-2 w-full
                    focus:border-primary-blue-500"
                  placeholder="Reset Password"
                />
                <div className="absolute inset-y-0 right-0 flex items-center pr-3">
                  {show ? (
                    <span onClick={() => setShow(!show)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M2.036 12.322a1.012 1.012 0 010-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 
                          0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                      </svg>
                    </span>
                  ) : (
                    <span onClick={() => setShow(!show)}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth="1.5"
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M3.98 8.223A10.477 10.477 0 001.934 12C3.226 16.338 7.244 19.5 
                          12 19.5c.993 0 1.953-.138 2.863-.395M6.228 6.228A10.45 10.45 0 0112 
                          4.5c4.756 0 8.773 3.162 10.065 7.498a10.523 10.523 0 01-4.293 5.774M6.228 
                          6.228L3 3m3.228 3.228l3.65 3.65m7.894 7.894L21 21m-3.228-3.228l-3.65-3.65m0 0a3 3 0 10-4.243-4.243m4.242 4.242L9.88 9.88"
                        />
                      </svg>
                    </span>
                  )}
                </div>
              </div>
              {password && (
                <div className="mt-4 password-checklist">
                  <PasswordChecklist
                    rules={['minLength', 'specialChar', 'number', 'capital']}
                    minLength={8}
                    value={password}
                    specialCharsRegex={
                      /^(?=.*[!@#$%^&*()\-=_+[\]{};':"\\|,.<>?])(?!.*(1234|aaaa|abcd)).*$/g
                    }
                    messages={{
                      specialChar:
                        'Password should contain special character and does not contain any sequences',
                    }}
                  />
                </div>
              )}

              <div className="text-center">
                <button
                  type="button"
                  className={` ${!validatedPassword() && 'opacity-50'}
                    mt-10 rounded-md bg-secondary-cornflowerblue-600 px-10 py-2 text-center text-sm font-semibold text-white`}
                  onClick={() => resetPassword()}
                  disabled={!validatedPassword()}
                >
                  Set Password
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetPassword;
